'use strict';

(function () {
  'use strict';

  angular.module('msCore').factory('quoteSvc', quoteSvc);

  quoteSvc.$inject = ['httpSvc'];

  function quoteSvc(httpSvc) {

    return {
      getAllQuotes: _getAllQuotes,
      getQuotesByTopic: _getQuotesByTopic,
      getRandomQuote: _getRandomQuote
    };

    /**
     * Get all quotes from the database.
     * @returns {*}
     * @private
     */
    function _getAllQuotes() {
      return httpSvc.get('/apiproxy/user/quotes');
    }

    /**
     * Retrieve all quotes for the given topic.
     * @param topic The topic to filter on.
     * @returns {*}
     * @private
     */
    function _getQuotesByTopic(topic) {
      return httpSvc.get('/apiproxy/user/quotes/bytopic/' + topic);
    }

    /**
     * Retrieves a random quote.
     * @returns random quote from database of quotes
     * @returns {*}
     * @private
     */
    function _getRandomQuote() {
      return httpSvc.get('/apiproxy/user/quotes/random');
    }
  }
})();